import { useState } from "react"
import { NavLink, Outlet } from "react-router-dom"
import allfcLogo from "@/assets/logos/allfc.svg"
import allfcLightLogo from "@/assets/logos/allfc-light.svg"
import Icon from "@/components/common/Icon"
import PublicMobileMenu from "@/components/layout/PublicMobileMenu"

const MENU_ITEMS = [
  { to: "/tournaments", label: "대회 목록" },
  { to: "/application", label: "참가 신청" },
  { to: "/bracket", label: "대진표" },
  { to: "/fee", label: "참가비 안내" },
]

/**
 * 활성 메뉴는 브랜드 레드 밑줄로만 표시한다 —
 * 배경 알약을 쓰면 헤더에 색면이 늘어 로고의 레드가 묻힌다.
 */
function navLinkClass({ isActive }: { isActive: boolean }): string {
  return `focus-ring app-txt-body2 block border-b-2 px-1 py-3 font-bold whitespace-nowrap transition ${
    isActive
      ? "border-app-primary-500 text-app-primary-600"
      : "border-transparent text-app-text-300 hover:text-app-text-400"
  }`
}

export default function PublicLayout() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  function onClickOpenMenu() {
    setIsMenuOpen(true)
  }

  function onCloseMenu() {
    setIsMenuOpen(false)
  }

  return (
    <div className="flex min-h-dvh flex-col bg-app-secondary-100 text-app-text-400">
      <a
        href="#main"
        className="focus-ring sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-app-secondary-100 focus:px-4 focus:py-2"
      >
        본문 바로가기
      </a>

      <header
        role="banner"
        className="sticky top-0 z-20 border-b border-app-secondary-500 bg-app-secondary-100"
      >
        <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between gap-4 px-5 py-4 sm:px-10 lg:gap-8">
          <NavLink
            to="/"
            aria-label="ALLFC 홈"
            className="focus-ring flex shrink-0 items-center"
          >
            <img
              src={allfcLogo}
              alt="ALLFC"
              className="h-11 w-auto sm:h-13"
            />
          </NavLink>

          <nav
            aria-label="주요 메뉴"
            className="hidden flex-1 items-center lg:flex"
          >
            <ul className="flex list-none items-center gap-7">
              {MENU_ITEMS.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    className={navLinkClass}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          <NavLink
            to="/login"
            className="focus-ring app-btn app-btn-sm app-btn-outline hidden lg:inline-flex"
          >
            관리자 로그인
          </NavLink>

          <button
            type="button"
            onClick={onClickOpenMenu}
            aria-label="메뉴 열기"
            className="focus-ring -mr-2 cursor-pointer p-2 text-app-text-300 transition hover:bg-app-secondary-300 hover:text-app-text-400 lg:hidden"
          >
            <Icon name="menu" />
          </button>
        </div>
      </header>

      <PublicMobileMenu
        items={MENU_ITEMS}
        isOpen={isMenuOpen}
        onClose={onCloseMenu}
      />

      <main
        id="main"
        tabIndex={-1}
        className="flex-1"
      >
        <Outlet />
      </main>

      <footer className="border-t-4 border-app-primary-500 bg-app-secondary-900 text-app-text-100">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-6 px-5 py-14 sm:flex-row sm:items-end sm:justify-between sm:px-10">
          <div>
            <img
              src={allfcLightLogo}
              alt="ALLFC"
              className="h-10 w-auto"
            />
            <p className="app-txt-body2 mt-4 text-app-secondary-700">
              격투스포츠 대회 참가 신청 · 대진 운영 플랫폼
            </p>
          </div>
          <p className="app-txt-caption text-app-secondary-700">
            © 2026 ALLFC. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  )
}
